import {AnalyticsService} from '../../../shared/services/analytics/analytics.service';
import {PathUrlEnum} from '../../../utils/analytics.utils';
import {tipo_sociedade} from '../../../utils/constants.utils';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ErrorMessage} from '../../../shared/models/error-message';
import PatternsUtils from '../../../utils/patterns.utils';
import {SellerPJDataPayload} from "../../../shared/models/sellerPj.model";
import {mapFormToDataPersonalSellerPjOne} from "../../../utils/seller-pj-mapper.util";
import CpfHelper from "../../../helpers/cpf.helper";
import {patchFormWithNestedObject} from "../../../utils/seller-mapper.utils";
import { phoneMask } from '../../../utils/masks.utils';
import { addCorporateNameSanitizer, corporateNameValidator, emailValidator } from '../../../helpers/validate-form.helper';

import { birthDateValidator } from '../../../helpers/birth-date.helper';

@Component({
  selector: 'app-seller-step-one-pj',
  templateUrl: './seller-step-one-pj.component.html',
  styleUrls: ['./seller-step-one-pj.component.scss'],
})
export class SellerStepOnePjComponent implements OnInit {
  @Output() formsComplete = new EventEmitter();
  @Input() dataCompany = new SellerPJDataPayload();
  @Output() dataForms = new EventEmitter<SellerPJDataPayload>();

  formStepOne: FormGroup;
  showError = false;
  errorMessage = '';
  sociedade = [...tipo_sociedade];

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

      getTextFieldError(controlName: string, label: string): string {
      const control = this.formStepOne.get(controlName);
      return ErrorMessage.getTextFieldError(control, label);
    }

    getDateFieldError(controlName: string, label: string): string {
      const control = this.formStepOne.get(controlName);
      return ErrorMessage.getBirthDateFieldError(control, label);
    }

       validatedate(control: FormControl): { [key: string]: any } | null {
      return birthDateValidator(control.value);
    }

      getEmailFieldError(controlName: string, label: string): string {
        const control = this.formStepOne.get(controlName);
        return ErrorMessage.getEmailFieldError(control, label);
      }

      getForgotFill(label: string): string {
        return ErrorMessage.forgotFill(label);
      }
  phoneMask = phoneMask;

  protected readonly maskCpfCnpj = CpfHelper.maskCpfCnpj;

  constructor(
    private analyticsService: AnalyticsService,
  ) {
  }

  ngOnInit(): void {
    this.initForm();
    this.getFormData(this.formStepOne, this.dataCompany);
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_PJ_DADOS_EMPRESA);
  }

  normalizeEmail(controlName: string): void {
  const control = this.formStepOne.get(controlName);
  if (!control) return;

  const value = (control.value || '').toString().trim().toLowerCase();

  if (value !== control.value) {
    control.setValue(value);
  }
}

  initForm() {
    this.formStepOne = new FormGroup({
      corporateName: new FormControl(this.dataCompany.corporateName, [Validators.required, corporateNameValidator()]),
      documentNumber: new FormControl({value: this.dataCompany.documentNumber, disabled: true}, [
        Validators.pattern(PatternsUtils.CNPJ),
      ]),
      companyType: new FormControl('', [Validators.required]),
      lastChangeDate: new FormControl('', [
        Validators.required,
        birthDateValidator
      ]),
      address_zipCode: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
      ]),
      address_state: new FormControl('', [Validators.required]),
      address_city: new FormControl('', [Validators.required]),
      address_district: new FormControl('', [Validators.required]),
      address_street: new FormControl('', [Validators.required]),
      address_number: new FormControl(''),
      address_complement: new FormControl(''),
      contact_email: new FormControl('', [
        Validators.required,
       emailValidator,
      ]),
      contact_phone: new FormControl('', [Validators.required, Validators.minLength(10)]),
    });

    addCorporateNameSanitizer(this.formStepOne, {
      controlNames: ['corporateName'], // opcional, já é o default
    });
  }

  isFormComplete() {
    this.formStepOne.statusChanges.subscribe(newStatus => {
      const formValue = this.formStepOne.getRawValue();
      Object.assign(this.dataCompany, mapFormToDataPersonalSellerPjOne(formValue));
      if (newStatus.toLowerCase() === 'valid') {
        this.formsComplete.emit(true);
        this.dataForms.emit(this.dataCompany);
      } else {
        this.formsComplete.emit(false);
      }
    });
  }

  getFormData(formGroup: FormGroup, data: SellerPJDataPayload) {
    patchFormWithNestedObject(formGroup, data);
    this.isFormComplete();
  }
}
